import React, { useState, useEffect, useCallback } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { useHistory } from "react-router-dom";
import { fetchGetMessage, fetchConfirmEmail } from "../../../../../../../api";
import AutoWithSwiper from "../../../../../../components/swiper/autowidth";
import NormalConfigConfirm from "../../../../../../../client/components/alert/config-confirm"
import { fetchUnifiedProcessing } from "../../../../utils";
import { useIntl } from "react-intl";
 

const NotificationMessage = props =>{
    const { data } = props;

    const handleClick = () =>{
        data?.clickHandle?.();
    }

    return <div className={cls.NotificationMessage} onClick={handleClick}>
        <Iconfont className={cls.Icon}>&#xe6ca;</Iconfont>
        <div className={cls.Message}>{data?.message?.message}</div>
        <Iconfont className={cls.Icon}>&#xe694;</Iconfont>
    </div>
}


export default props =>{
    useStyles(cls);
    const { customer, setLoading, onlyCheckoutLoginHandle } = props;
    const [messages, setMessages] = useState(null);
    const histroy = useHistory();
    const Intl = useIntl();

    useEffect(async () =>{
        let arrs = [];
        let message;
        if(customer?.id){
            if(customer?.temporary){
                arrs.push({
                    id: 1,
                    message: {
                        message: Intl.formatMessage({ id: "set_password_more_discount", defaultMessage: "Set your password to get more discount!" })
                    }
                });
            }else if(customer?.email && !customer?.isConfirmEmail){
                let response = await fetchGetMessage("M1543");
                if(response?.code === 200 && response?.result?.message){
                    arrs.push({
                        id: 2,
                        message: response.result,
                        clickHandle:() =>{
                            verifyEmailHandle(customer?.email);
                        }
                    });
                }
            }
        }else{
            let response = await fetchGetMessage("M1518");
            if(response?.code === 200 && response?.result?.message){
                arrs.push({
                    id: 3,
                    message: response.result,
                    clickHandle:() =>{
                        onlyCheckoutLoginHandle?.();
                    }
                });
            }
        }
        
        setMessages(arrs);
    },[customer?.id]);

    const ifOwnEmail = useCallback((email) =>{
        return email?.endsWith("@chic-fusion.com") || email?.endsWith("@ivrose.com") || email?.endsWith("@boutiquefeel.com")
    }, [])

    const verifyEmailHandle = useCallback(async (email) =>{
        if(ifOwnEmail(email)){
            histroy.push("/user/change-email")
        }else{
            setLoading(true);
            let response = await fetchConfirmEmail(email);
            if(response?.code === 200){
                let isHtml = !!response?.prompt?.html;
                NormalConfigConfirm({
                    boxStyle:{
                        padding:isHtml?"20px 0px":"25px",
                    },
                    message:{
                        text:response?.prompt?.html || Intl.formatMessage({ id: "check_mail_box", defaultMessage: "A verification link has been sent to your email address, please check your mailbox." }),
                        style:{
                            fontFamily: isHtml?'Roboto':'Roboto-Medium',
                            fontSize: '14px',
                            lineHeight: isHtml?'normal':'17px',
                            color:'#222222',
                            textAlign: 'center'
                        },
                        html:isHtml
                    },
                    btn1:{
                        text: Intl.formatMessage({ id: "ok", defaultMessage: "Ok" }),
                    },
                });
            } else {
                NormalConfigConfirm({
                    boxStyle:{
                        padding: "25px",
                    },
                    message:{
                        text:response?.result,
                        style:{
                            fontFamily: 'Roboto',
                            fontSize: '14px',
                            lineHeight: '17px',
                            color:'#222222',
                            textAlign: 'center'
                        },
                        html:false
                    },
                    btn1:{
                        text: Intl.formatMessage({ id: "ok", defaultMessage: "Ok" }),
                    },
                });
            }
        }
        setLoading(false);
    }, [messages]);

    return <div className={cls.NotificationSwiper}>
        <AutoWithSwiper
            items={messages}
            options={{
                loop:messages?.length > 1,
                autoplay: messages?.length > 1 ? {
					delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
				} : false,
            }}
            render={(item, index) =><NotificationMessage key={index} data={item} />}
        />
    </div>
}